import React from 'react'
import type { BodyRowConfig } from '../types'

export const RowNumberBodyCell = (props: BodyRowConfig) => {
  return <td className="bg-secondary-subtle">{(props?._index ?? 0) + 1}</td>
}
